export default __webpack_public_path__ + "static/media/prevImg.3b525168.svg";